import { useAppContext } from '../../../AppContext/AppContext';
import { useOfferContext } from '../../../OfferContext/OfferContext';
import {
  getSelectedTariffConfiguration,
  isEnergyDynamicProductConfiguration,
} from '../../../utils/utils';
import { DefaultCtaContent } from '../../DefaultCtaContent/DefaultCtaContent';
import OfferLoadingOrError from '../../OfferLoadingOrError/OfferLoadingOrError';

export const TariffsCta = () => {
  const { modules, orderFlow } = useAppContext();
  const { offer, offerLoading, offerError } = useOfferContext();

  const configuration = getSelectedTariffConfiguration(offer, modules, orderFlow);

  const showContent = Boolean(offer && !offerLoading && !offerError);

  const energyCosts = isEnergyDynamicProductConfiguration(configuration)
    ? configuration.averagePrices.expectedPaymentGrossPerMonth
    : configuration?.expectedPaymentGrossPerMonth;

  return (
    <div style={{ marginBottom: 'var(--spacing-xs)' }} data-testid="tariffs-cta">
      <OfferLoadingOrError />

      {showContent && energyCosts && <DefaultCtaContent value={parseFloat(energyCosts.value)} />}
    </div>
  );
};
